import React from 'react';
/**
 * サムネイルボタンの生成
 */
const createThumbnailButtons = (itemList, activeIndex, onThumbnailClick) => {
    return itemList.map((fileName, index) => {
        let className = '';
        // サムネイルがアクティブな場合
        if (activeIndex === index) {
            className = ' active';
        }
        return (React.createElement("li", { key: `${fileName}${index}`, onClick: () => onThumbnailClick(index), className: className },
            React.createElement("img", { src: fileName })));
    });
};
const ItemThumbnailNav = ({ itemList, activeIndex, onThumbnailClick }) => {
    return (React.createElement(React.Fragment, null, createThumbnailButtons(itemList, activeIndex, onThumbnailClick)));
};
export default ItemThumbnailNav;
